import Cookies from 'js-cookie';
import { Product } from '~/types/products';

const discountTextNoETF = 'Discounted price per month with Auto Pay, for 12 months';
const discountTextWithETF = `${discountTextNoETF}. ETF applies`;
const netflixPromoText = 'Netflix & Pro Wi-Fi $30/mo. + taxes';

const getShortLegal = (
  product: Product,
  indianaOffer: boolean,
  rewardSelected?: boolean,
  netflixOffer?: boolean
): string => getLegalPreAutoPayDiscount(product, indianaOffer, rewardSelected, netflixOffer);

const getLegalPreAutoPayDiscount = (
  product: Product,
  indianaOffer: boolean,
  rewardSelected?: boolean,
  netflixOffer?: boolean
): string => {
  const { shortLegal, shortLegalIndiana, shortLegalNetflix, is200, is500, is1Gig, is2Gig, is5Gig, is7Gig } =
    product ?? {};
  const offerType = Cookies.get('addressOfferType');

  if (indianaOffer && shortLegalIndiana) return shortLegalIndiana.replace('per month ', '');

  if (netflixOffer) {
    switch (offerType) {
      case 'OFS':
      case 'OFS_test':
      case 'OFS_test3':
        switch (true) {
          case is200:
            return `Fiber 200 $29.99/mo. for 12 months w/ Auto Pay. ${netflixPromoText}`;
          case is500:
            return `Fiber 500 $29.99/mo. for 12 months w/ Auto Pay. ${netflixPromoText}`;
          case is1Gig:
            return `Fiber 1 Gig $49.99/mo. for 12 months w/ Auto Pay. ${netflixPromoText}`;
          case is2Gig:
            return `Fiber 2 Gig $69.99/mo. for 12 months w/ Auto Pay. ${netflixPromoText}`;
          case is5Gig:
            return `Fiber 5 Gig ${offerType === 'OFS_test3' ? '$94.99' : '$99.99'}/mo. for 12 months w/ Auto Pay. ${netflixPromoText}`;
          default:
            return shortLegalNetflix;
        }
      default:
        return shortLegalNetflix;
    }
  }

  switch (offerType) {
    case 'OFS_test':
    case 'OFS_test2':
    case 'OFS_test4':
    case 'OFS_test3':
      if (!is200) return discountTextNoETF;
      return shortLegal;
    case 'eeroFree':
      if (is500) return `per month with Auto Pay, then $49.99 mo. 2-12. ${rewardSelected ? 'ETF applies' : ''}`;
      if (is1Gig) return `per month with Auto Pay, then $69.99 mo. 2-12. ${rewardSelected ? 'ETF applies' : ''}`;
      if (is2Gig) return `per month with Auto Pay, then $104.99 mo. 2-12. ${rewardSelected ? 'ETF applies' : ''}`;
      if (is5Gig) return `per month with Auto Pay, then $134.99 mo. 2-12 ${rewardSelected ? 'ETF applies' : ''}`;
      return shortLegal;
    case 'OFS':
      return !is7Gig ? discountTextNoETF : shortLegal;
    case 'laOffer':
      if (!is200 && !is500 && !is2Gig && !is7Gig) return discountTextWithETF;
      if (is2Gig) return discountTextNoETF;
      return shortLegal;
    case 'laOfferiONT':
      if (!is200 && !is2Gig && !is7Gig) return discountTextWithETF;
      if (is2Gig) return discountTextNoETF;
      return shortLegal;
    default:
      return shortLegal;
  }
};

export default getShortLegal;
